export default "__VITE_ASSET__B$JTERm1__"